const tasks = new Map();
let taskRunning = false;
function runTask(handle) {
    if (taskRunning) {
        setTimeout(runTask, 0, handle);
    }
    else {
        if (tasks.has(handle)) {
            const task = tasks.get(handle);
            taskRunning = true;
            try {
                task.callback.apply(void 0, task.args);
            }
            finally {
                clearImmediate(handle);
                taskRunning = false;
            }
        }
    }
}
function NextTickImplementation(process) {
    return (handle) => {
        process.nextTick(() => {
            runTask(handle);
        });
    };
}
function PostMessageImplementation(global) {
    const messagePrefix = `setImmediate$${Math.random()}$`;
    const length = messagePrefix.length;
    global.addEventListener('message', (event) => {
        if ((event.source === global)
            && (typeof event.data === 'string')
            && (event.data.indexOf(messagePrefix) === 0)) {
            runTask(+event.data.slice(length));
        }
    }, false);
    return (handle) => {
        global.postMessage(messagePrefix + handle, '*');
    };
}
function MessageChannelImplementation() {
    const channel = new MessageChannel();
    channel.port1.onmessage = (event) => {
        const handle = event.data;
        runTask(handle);
    };
    return (handle) => {
        channel.port2.postMessage(handle);
    };
}
function ReadyStateChangeImplementation(doc) {
    const html = doc.documentElement;
    return (handle) => {
        let script = doc.createElement('script');
        script['onreadystatechange'] = () => {
            runTask(handle);
            script['onreadystatechange'] = null;
            html.removeChild(script);
        };
        html.appendChild(script);
    };
}
function SetTimeoutImplementation() {
    return (handle) => {
        setTimeout(runTask, 0, handle);
    };
}
function CanUsePostMessage(global) {
    if (global.postMessage && !global.importScripts) {
        let postMessageIsAsynchronous = true;
        let oldOnMessage = global.onmessage;
        global.onmessage = () => {
            postMessageIsAsynchronous = false;
        };
        global.postMessage('', '*');
        global.onmessage = oldOnMessage;
        return postMessageIsAsynchronous;
    }
    else {
        return false;
    }
}
function GetRegisterImmediateImplementation(global) {
    if ({}.toString.call(global.process) === '[object process]') {
        return NextTickImplementation(global.process);
    }
    else if (CanUsePostMessage(global)) {
        return PostMessageImplementation(global);
    }
    else if (global.MessageChannel) {
        return MessageChannelImplementation();
    }
    else if (global.document
        && ('onreadystatechange' in global.document.createElement('script'))) {
        return ReadyStateChangeImplementation(global);
    }
    else {
        return SetTimeoutImplementation();
    }
}
function init() {
    const globalThis = (function () {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function () {
                return this;
            },
            configurable: true
        });
        const globalThis = __magic__;
        delete Object.prototype['__magic__'];
        return globalThis;
    }());
    registerImmediate = GetRegisterImmediateImplementation(globalThis);
}
let registerImmediate;
let nextHandle = 1;
export function setImmediate(callback, ...args) {
    if (registerImmediate === void 0) {
        init();
    }
    tasks.set(nextHandle, { callback: callback, args: args });
    registerImmediate(nextHandle);
    return nextHandle++;
}
export function clearImmediate(handle) {
    tasks.delete(handle);
}
//# sourceMappingURL=set-immediate.js.map